import React from "react";
import {
  OPTION_ENTRY_CHAR,
  parseOptionEntryText,
  textHasBulkOptionSeparators,
} from "../../../utils/formBuilderOptions";
import FieldHint from "./FieldHint";
import { hintsPt } from "./hintsPt";

export default function DraftOptionsInput({
  inputValue,
  onInputChange,
  items,
  onAddLabels,
  onRemoveItem,
  onRemoveLastItem,
  justAdded,
  stopPropagation,
}) {
  const stop = stopPropagation ? (e) => e.stopPropagation() : undefined;

  function handleChange(e) {
    const v = e.target.value;
    if (v.includes(OPTION_ENTRY_CHAR)) {
      const parts = v.split(OPTION_ENTRY_CHAR);
      const head = parts.slice(0, -1).join(OPTION_ENTRY_CHAR);
      const tail = parts[parts.length - 1];
      if (head) onAddLabels(parseOptionEntryText(head));
      onInputChange(tail);
    } else {
      onInputChange(v);
    }
  }

  function commitInput() {
    const labels = parseOptionEntryText(inputValue);
    if (labels.length) onAddLabels(labels);
    onInputChange("");
  }

  function handlePaste(e) {
    const pasted = e.clipboardData?.getData("text") || "";
    if (!textHasBulkOptionSeparators(pasted)) return;
    e.preventDefault();
    onAddLabels(parseOptionEntryText(pasted));
  }

  return (
    <div className="mb-2">
      <label className="block text-[11px] font-medium text-gray-700 mb-1">{hintsPt.optionsDraftLabel}</label>
      <input
        className="w-full border border-gray-300 rounded-md px-2 py-1.5 text-xs focus:outline-none focus:ring-2 focus:ring-emerald-500"
        placeholder={hintsPt.optionsDraftPlaceholder}
        value={inputValue}
        onClick={stop}
        onChange={handleChange}
        onPaste={handlePaste}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            commitInput();
          }
          if (e.key === "Backspace" && !inputValue && items.length > 0 && onRemoveLastItem) {
            onRemoveLastItem();
          }
        }}
        onBlur={commitInput}
      />
      {(items.length > 0 || justAdded) && (
        <div className="mt-2">
          {justAdded && (
            <div className="text-[11px] text-emerald-700 mb-1">
              Adicionada: <span className="font-medium">{justAdded}</span>
            </div>
          )}
          {items.length > 0 && (
            <div className="flex flex-wrap gap-1.5">
              {items.map((lab) => (
                <button
                  key={lab}
                  type="button"
                  onClick={(e) => {
                    stop?.(e);
                    onRemoveItem?.(lab);
                  }}
                  className="inline-flex items-center gap-1 rounded-full border border-emerald-200 bg-emerald-50 px-2 py-0.5 text-[11px] text-emerald-800 hover:bg-emerald-100"
                  title="Clique para remover"
                >
                  <span className="truncate max-w-[240px]">{lab}</span>
                  <span aria-hidden className="text-emerald-700">
                    ×
                  </span>
                </button>
              ))}
            </div>
          )}
        </div>
      )}
      <FieldHint className="mt-1">{hintsPt.optionsDraftHelp}</FieldHint>
    </div>
  );
}
